import Orders from './orders';
import Products from './products';

export default {
  Orders,
  Products,
};
